import { Injectable } from '@angular/core';
import { Subject, Observable, interval } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ResizeService {
  public resizeSubject: Subject<any> = new Subject();
  public resizeObservable: Observable<any> = this.resizeSubject.pipe(
    debounceTime(500)
  );
  public detectObservable: Observable<number> = interval(100);
  
  constructor() { }
}
